import {AppState} from "../../../store/store";
import React, {useEffect, useState} from "react";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import {connect, useDispatch} from "react-redux";
import {updateAlarms} from "../../../services/alarms.service";
import {Control, Form} from "react-redux-form";
import LensIcon from "@material-ui/icons/Lens";
import CustomInput from "../../../components/custom-input/custom-input";
import CustomSelect from "../../../components/custom-select/custom-select";
import {Button} from "@material-ui/core";

export interface AlarmProps {
    isActive?: boolean;
    temperatureUp?: string;
    temperatureDown?: string;
    hysteresis?: string;
    reactionTime?: string;
}

export interface PureAlarmCardProps {
    id: string;
    state: AppState,
    alarm: AlarmProps,
    alarmName: string
}

const PureAlarmCard: React.FC<PureAlarmCardProps> = (props) => {
    const alarmState = _.get(props.state, 'alarms.' + props.id, {});
    const [currentAlarm, setCurrentAlarm] = useState(props.alarm);
    const [currentAlarmStatus, setCurrentAlarmStatus] = useState<boolean>(false);
    const [dissableButtons, setDissableButtons] = useState(false)
    const {t} = useTranslation();
    useEffect(() => {
        setCurrentAlarm(props.alarm);
        setCurrentAlarmStatus(_.get(props.alarm, 'isActive', false));
    }, [props.alarm]);
    const isInput = () => {
        return !props.id.includes('input');
    }
    const isAnalogOutput = () => {
        return props.id.includes('analog');
    }


    const handleSaveAlarm = () => {
        setDissableButtons(true);
        const currentAlarm = _.get(props.state, 'alarms.' + props.id, {});
        updateAlarms(currentAlarm, props.id, false).finally(() => setTimeout(() => setDissableButtons(false), 1000))
        setCurrentAlarmStatus(false);
    }
    const handleSubmit = (al: any) => {
        setDissableButtons(true);
        const currentAlarm = _.get(props.state, 'alarms.' + props.id, {});
        updateAlarms(currentAlarm, props.id, !!!currentAlarmStatus).finally(() => setTimeout(() => setDissableButtons(false), 1000))
        setCurrentAlarmStatus(!currentAlarmStatus);
    }
    return (
        <div className='card default-card'>
            <div className="card-body">
                <Form
                    model='alarms'
                    onSubmit={(al) => handleSubmit(al)}>
                        <div className='d-flex justify-content-center'>
                                <span className=''>{currentAlarmStatus ? t('active') :  t('notactive')}</span>
                                <LensIcon className={currentAlarmStatus ? 'ml-2 greenLens' : 'ml-2 redLens'}/>
                            </div>
                    <div className='card-title-container'>
                        <div className='card-title-with-icon'>
                            <span className='card-title'>{props.alarmName || props.id}</span>
                        </div>
                        <span className='card-title'>{t('alert')}</span>
                    </div>
                    {
                        isInput() && <div>
                            {
                                !isAnalogOutput() && <div className='default-row'>
                                    <div className='default-field'>
                                        <Control
                                            model={"." + props.id + ".valueUp"}
                                            component={CustomInput}
                                            defaultValue={currentAlarm.temperatureUp}
                                            label={t('alarms.tempUp')}
                                            id={"." + props.id + ".valueUp"}/>
                                    </div>
                                    <div className='default-field'>
                                        <Control
                                            model={"." + props.id + ".valueDown"}
                                            component={CustomInput}
                                            defaultValue={currentAlarm.temperatureDown}
                                            label={t('alarms.tempDown')}
                                            id={"." + props.id + ".valueDown"}/>
                                    </div>
                                </div>
                            }
                            <div className='default-row'>
                                <div className='default-field'>
                                    <Control
                                        model={"." + props.id + ".hysteresis"}
                                        component={CustomInput}
                                        // type='number'
                                        defaultValue={parseFloat(currentAlarm.hysteresis!).toFixed(2)}
                                        label={t('alarms.hysteresis')}
                                        id={"." + props.id + ".hysteresis"}/>
                                </div>
                                <div className='default-field'>
                                    <Control
                                        model={"." + props.id + ".reactionTime"}
                                        component={CustomInput}
                                        defaultValue={currentAlarm.reactionTime}
                                        label={t('alarms.reactionTime')}
                                        id={"." + props.id + ".reactionTime"}/>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        !isInput() && <div>
                            <div className='default-row'>
                                <div className='default-field'>
                                    <Control
                                        model={"." + props.id + ".reactionTime"}
                                        component={CustomInput}
                                        defaultValue={currentAlarm.reactionTime}
                                        label={t('alarms.reactionTime')}
                                        id={"." + props.id + ".reactionTime"}/>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        isAnalogOutput() && <div>
                            <div className='default-row'>
                                <div className='default-field'>
                                    <Control
                                        model={"." + props.id + ".valueUp"}
                                        component={CustomInput}
                                        label={t('alarms.tempUp')}
                                        id={"." + props.id + ".alarmValue"}/>
                                </div>
                                <div className='default-field'>
                                    <Control
                                        model={"." + props.id + ".valueDown"}
                                        component={CustomInput}
                                        label={t('alarms.tempDown')}
                                        id={"." + props.id + ".alarmValue"}/>
                                </div>
                            </div>
                        </div>
                    }
                    <div className='modal-action-row'>
                        <Button variant="outlined" disabled={dissableButtons} onClick={handleSaveAlarm} type='button' color="primary" className='modal-default-button'>
                            {t('save')}
                        </Button>
                        <Button variant="contained" disabled={dissableButtons} type='submit' color="primary" className='modal-default-button'>
                            {!currentAlarmStatus ? t('activate') : t('deactivate')}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

const mapStateToProps = (state: AppState) => ({
    state: state
});

export const AlarmCard = connect(mapStateToProps)(PureAlarmCard);